module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0